
<p>
    Fees paid through the ACE system are non-refundable.Before submitting payment, please be sure you are completing the correct certification application. Fees paid for the wrong application will not be transferred to another application. Fees are paid through NIC Alabama, a third-party payment provider. 
</p>
<div class="item d-flex">
    Date Completed: <div class="value">{{artifact.completedDate | date:'MM/dd/yyyy' }}</div>
</div>
<div class="ms-3 mt-3">
    <div>Total Amount: <span>{{feeSummary()?.feeTotal | currency}}</span></div>
    <div>Credit Amount: <span>{{feeSummary()?.creditAmount | currency}}</span></div>
    <div>Paid Amount: <span>{{feeSummary()?.feeTotalPaid | currency}}</span></div>
    <div>Total Received: <span>{{feeSummary()?.totalReceived | currency}}</span></div>
</div>
<div class="" *ngIf="artifact.artifactStatus != ARTIFACT_STATUS.COMPLETE">
    <div class="ps-2 pt-2">
        <button mat-stroked-button color="accent" (click)="paymentRoute()" [disabled]="appWizService.isReadOnly(artifact)" >{{feeSummary()?.balanceAmount > 0 ? 'Pay': 'Use Credit'}}</button>
    </div>
</div>
